import { useFocusStoreDangerously } from '@please/lrud'
import { Direction, FocusState, Orientation } from '@please/lrud/dist/types'

export const useInternalGridBoxNav = () => {
  const focusStore = useFocusStoreDangerously()

  const getIndex = (length: number, index: number) => {
    if (length === 0 || index > length || index < 0) {
      return
    }
    return index
  }

  const isInternalGridBoxNav: (
    focusState: FocusState,
    currentNodeId: string,
    targetNodeId: string,
    orientation: Orientation,
    direction: Direction,
  ) => boolean = (
    focusState,
    currentNodeId,
    targetNodeId,
    orientation,
    direction,
  ) => {
    const gridNodeChildren = focusState.nodes[currentNodeId]?.children
    if (!gridNodeChildren || gridNodeChildren.includes(targetNodeId)) {
      return false
    }
    const parentId = focusState.nodes[targetNodeId]?.parentId
    if (!parentId) {
      return false
    }
    const parentNode = focusState.nodes[parentId]
    if (!parentNode) {
      return false
    }
    const parentNodeOrietation = parentNode.orientation
    const parentsChildren = parentNode.children
    const index = parentsChildren.indexOf(targetNodeId)
    const distance =
      parentNodeOrietation === orientation
        ? direction === 'forward'
          ? 1
          : -1
        : 0
    const newIndex = getIndex(parentsChildren.length - 1, index + distance)
    if (newIndex !== undefined && index !== newIndex) {
      return true
    } else {
      return isInternalGridBoxNav(
        focusState,
        currentNodeId,
        parentId,
        orientation,
        direction,
      )
    }
  }

  const onArrowHandler = (e: LRUDEvent, currentNodeId: string) => {
    const focusState = focusStore.getState()
    const targetNodeId = e.targetNode.focusId
    const orientation: Orientation =
      e.key === 'right' || e.key === 'left' ? 'horizontal' : 'vertical'
    const direction: Direction =
      e.key === 'down' || e.key === 'right' ? 'forward' : 'backward'
    if (
      isInternalGridBoxNav(
        focusState,
        currentNodeId,
        targetNodeId,
        orientation,
        direction,
      )
    ) {
      e.stopPropagation()
    }
  }

  return {
    onArrowHandler,
  }
}
